export default {
    OPEN: "@OPEN",
    CLOSE: "@CLOSE",
    SET: "@SET_VALUE"
};
